// CSS
import "./LabelledInputBox.css"

// COMPONENTS
import InputBox from "./InputBox.js";

/** 
 * This component renders a labelled input box. Use this for single-line inputs. See LabelledTextAreaBox for multiline inputs.
 * 
 * @param   {string} label The label that indicates what information should be entered.
 * @param   {string} labelColour The style of the label (light/dark).
 * @param   {string} type The type of input box.
 * @param   {string} placeholder The type of data to be entered.
 * @param   {boolean} required Whether or not the input box is required.
 * @param   {(e: React.ChangeEvent<HTMLInputElement>) => void} onChange The function to call when the input value is changed.
 * @param   {(e: React.FocusEvent<HTMLInputElement>) => void} onBlur The function to call when the input loses focus.
 * @returns {ReactElement} A React element that renders a labelled input box. 
 */
export default function LabelledInputBox({label, labelColour, type, placeholder, required, onChange, onBlur}) {
    return (
        <div className="labelled-input-box">
            <div className={`labelled-input-box-label-${labelColour}`}>{label}</div>
            <InputBox 
                type={type} 
                placeholder={placeholder} 
                inputName={label} 
                required={required}
                onChange={onChange}
                onBlur={onBlur}
            />
        </div>
    )
}